import {
  allTotalRows,
  TRevenueSnapshotKeys,
} from 'legacy/lut/classes/models/partner360/ELT/IELTFinancialData'

export const isTotalRowsColumn = (keyValue: string, onlyGrandRow?: boolean) => {
  if (onlyGrandRow) {
    return ['GrandTotal'].includes(keyValue)
  }
  return allTotalRows.includes(keyValue as TRevenueSnapshotKeys)
}
